/* Edits the state whenever siteId is changed */

export default function isFileStructureShowing(state = [], action) {
	switch (action.type) {
	case 'STRUCT_STATUS':
		return action.status;

	default:
		return state;
	}
}
